// data/AppDev/AppLogoSlider.jsx
import React from "react";
import Slider from "../../components/Slider/Slider";

const items = [
  { src: "/assets/tools_logo/flutter.svg", alt: "Flutter" },
  { src: "/assets/tools_logo/kotlin.svg", alt: "Kotlin" },
  { src: "/assets/tools_logo/swift.svg", alt: "Swift" },
  { src: "/assets/tools_logo/react.svg", alt: "React Native" },
  { src: "/assets/tools_logo/typescript.svg", alt: "TypeScript" },
  { src: "/assets/tools_logo/firebase.svg", alt: "Firebase" },
];

const renderItem = (item) => <img src={item.src} alt={item.alt} loading="lazy" />;

const AppLogoSlider = () => (
  <Slider
    items={items}
    renderItem={renderItem}
    speedDesktop="24s"
    speedMobile="20s"
    label="Unser Technologie-Stack für mobile Apps"
  />
);

export default AppLogoSlider;
